import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
render(<HashRouter data-id="element-119">
    <App data-id="element-120" />
  </HashRouter>, document.getElementById('root'));